import { ToArrPipe } from './toArray/toArray.pipe';
import { NgModule } from '@angular/core';
import { AbsolutePathPipe } from './absolute-path/absolute-path.pipe';
import { PlusPipe } from './plus/plus.pipe';
import { FilterIngPipe } from './filterIng/filterIng.pipe';
import { groupByCategoryPipe } from './groupByCategory/groupByCategory.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
@NgModule({
    imports: [
    ],
    declarations: [
        AbsolutePathPipe,
        PlusPipe,
        FilterIngPipe,
        groupByCategoryPipe,
        ToArrPipe,
        SafeHtmlPipe
    ],
    exports: [
        AbsolutePathPipe,
        PlusPipe,
        FilterIngPipe,
        groupByCategoryPipe,
        ToArrPipe,
        SafeHtmlPipe
    ]
})

export class PipesModule {

}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts